import { Link } from "react-router";
import Form from "./Form";
import "./ErrorPageContent.css";
import Footer from "@/components/common/footer/Footer";

const ErrorPageContent = () => {
  return (
    <div className="error_page footer_apps_widget">
      <div className="error_header">
        <h2>We&apos;re sorry! it appears something isn&apos;t here</h2>
      </div>
      <div className="error-content">
        <p>
          We couldn&apos;t find the page you are looking for. We&apos;re on the
          case. Perhaps you&apos;d like to:
        </p>
      </div>
      <div className="page404">
        <img
          className="img-fluid img-thumb contain"
          src="/assets/images/resource/promo3.jpg"
          alt="error.png"
        />
      </div>
      <div className="helplinks page404">
        <ul className="pagelinks">
          <li className="pageurls">
            <Link to="/auctions" className="searchlink navigationlinks">
              Search Properties
            </Link>
          </li>
          <li className="pageurls">
            <Link to="/" className="offerlink navigationlinks">
              Offers & promotions
            </Link>
          </li>
          <li className="pageurls">
            <Link to="/support" className="helpcenter navigationlinks">
              Visit help center
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ErrorPageContent;
